<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-1 text-center" v-text="'Włączanie usługi'" />
            <h5 class="mb-0 text-center text-danger" v-text="'Autoryzacja'" />
        </template>

        <div class="text-center mb-3 text-warning">
            <a-icon icon="WarningFull" width="40px" height="40px" />
        </div>

        <p class="text-primary text-center font-weight-semi typo--lg">
            <span class="text-danger">Uwaga!</span>
            W kolejnym kroku musimy dokonać płatności autoryzacyjnej.<br>
            Podana przez Ciebie karta ulegnie weryfikacji poprzez pobranie z konta opłaty w wysokości 1 zł.<br>
            Po zweryfikowaniu ważności karty i dostępności środków na koncie opłata zostanie zwrócona.
        </p>

        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Wróć"
                @click="$store.dispatch('toggleModal', false)"
            />
            <the-btn
                class="btn-secondary"
                text="Przejdź do płatności autoryzacyjnej"
                @click="goToPayment"
            />
        </template>
    </ui-modal>
</template>

<script>
export default {
    computed: {
        paymentUrl() {
            return this.$store.getters.modalState.args.paymentUrl
        }
    },

    methods: {
        goToPayment() {
            if (!this.paymentUrl) {
                this.$store.dispatch('toggleModal', false)
                this.$router.push({ name: 'drs' })
                return
            }

            window.location.href = this.paymentUrl
        }
    }
}
</script>
